import {isNil} from 'ramda';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Form, Header, Icon, Message} from 'semantic-ui-react';
import {withRouter} from 'react-router';
import HeaderSubHeader from 'semantic-ui-react/dist/commonjs/elements/Header/HeaderSubheader';
import styled from 'styled-components';
import {GreenButton, DefaultButton, ButtonsGroup} from '../../components/Button/ButtonMix';
import {BlueContainer} from '../../components/Container/ContainerMix';
import {FormInputLogin} from '../../components/Form/FormInputMix';
import {resetPassword} from '../../api';
import {saveUser} from '../../util/Session';

const MINIMUM_PASSWORD_LENGTH = 6;

const StyledForm = styled(Form)`
  padding: 10px 0 10px 0;
`;

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      errors: [],
      password: '',
      passwordConfirmation: ''
    };
  }
  
  handleChange = (e, {name, value}) => this.setState({errors: [], [name]: value});
  
  onChangePassword = () => {
    const {router, location} = this.props;
    const {password, passwordConfirmation} = this.state;
    const {token, email} = location.query;
    
    const errors = [];
    
    if (password.length < MINIMUM_PASSWORD_LENGTH) {
      errors.push(`Password must be at least ${MINIMUM_PASSWORD_LENGTH} characters long`);
    } else if (password !== passwordConfirmation) {
      errors.push('Passwords do not match');
    }
    
    // check for validation errors
    if (errors.length > 0) {
      this.setState({errors: errors});
      return null;
    }
    
    return resetPassword(token, email, password, passwordConfirmation)
      .then(response => {
        saveUser(response.data.user);
        router.push('/dashboard');
        return null;
      })
      .catch(e => {
        const apiErrors = e.response ? [e.response.data.error] : [e.message];
        this.setState({errors: apiErrors});
      });
  };
  
  render() {
    const {router} = this.props;
    const {errors, password, passwordConfirmation} = this.state;
    
    const isError = !isNil(errors) && errors.length > 0;
    
    return (
      <BlueContainer>
        <Header as="h1" icon textAlign="center">
          <Icon name="unlock" circular/>
          <Header.Content>Reset password</Header.Content>
          <HeaderSubHeader>Enter a new password</HeaderSubHeader>
        </Header>
        <StyledForm error={isError}>
          <Message error icon>
            <Icon name="exclamation triangle"/>
            <Message.Content>
              <Message.Header>Error</Message.Header>
              {[errors].filter(e => !isNil(e)).join(', ')}
            </Message.Content>
          </Message>
          <FormInputLogin fluid value={password} label="Password" type="password" name="password" placeholder="Password" onChange={this.handleChange} required/>
          <FormInputLogin fluid value={passwordConfirmation} label="Password confirmation" type="password" name="passwordConfirmation" placeholder="One more time" onChange={this.handleChange} required/>
        </StyledForm>
        <ButtonsGroup>
          <DefaultButton onClick={() => router.push('/login')}>Cancel</DefaultButton>
          <GreenButton onClick={this.onChangePassword}>Submit</GreenButton>
        </ButtonsGroup>
      </BlueContainer>
    );
  }
}

ResetPassword.propTypes = {
  router: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default withRouter(ResetPassword);



// WEBPACK FOOTER //
// ./src/pages/Login/ResetPassword.js